<template>
  <v-dialog
    persistent
    max-width="600px"
    :value="value"
    @click:outside="closeDialog"
    >
    <v-toolbar
      >
      <v-toolbar-title>{{$t('f.title')}}</v-toolbar-title>
      <v-spacer />
      <v-btn icon @click="closeDialog">
        <v-icon>mdi-window-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                :value="$t('f.name', {email: 'udp.webi@gmail.com'})"
                :label="$t('f.recipient')"
                readonly
                />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="subject"
                :label="$t('f.subject')"
                required
                />
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="body"
                :label="$t('f.body')"
                required
                ref="body_input"
                />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="closeDialog"
          >{{$t('cancel')}}</v-btn>
        <v-btn
          text
          color="blue darken-1"
          target="_blank"
          :href="submit_url"
          >{{$t('submit')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {debug} from '@/api/logging'
export default {
  name: "FeedbackDialog",
  watch: {
    value(v) {
      if(!v) return
      this.subject = this.$t("f.dsubject")
      // this.body = `問題網址：${window.location.href}\n意見：`
      this.body = this.$t("f.dbody", {href: window.location.href})
      this.$nextTick(() => {
        const bi = this.$refs['body_input']
        debug('bi', bi)
        const inp = bi.$refs['input']
        debug('inp', inp)
        setTimeout(()=>{
          inp.focus()
        }, 200)
      })
    },
  },
  methods: {
    closeDialog() {
      this.$emit('input', false)
    },
  },
  computed: {
    submit_url() {
      const uri = `mailto:` + encodeURIComponent(this.email)
      const query = [
        "subject=" + encodeURIComponent(this.subject),
        "body=" + encodeURIComponent(this.body),
      ]
      return [uri, query.join('&')].join('?')
    },
  },
  data() {
    return {
      // email: '聯合百科意見反應<lichih.wu@creart.tw>',
      // email: '聯合百科意見反應<udp.webi@gmail.com>',
      subject: "",
      body: "",
    }
  },
  props: {
    value: {},
  },
}
</script>
